'use client';

import { FC, useEffect } from 'react';
import { SliceLike, SliceZone, SliceZoneLike } from '@prismicio/react';
import { components } from '@/slices';

import { useAnchor } from '@/hooks';
import { scrollToAnchor } from '@/utils';

type Props = {
  slices: SliceZoneLike<SliceLike<string>>;
};

export const ClientPage: FC<Props> = ({ slices }) => {
  const anchor = useAnchor();

  useEffect(() => {
    if (!anchor) return;
    scrollToAnchor(anchor);
  }, [anchor]);
  return <SliceZone slices={slices} components={components} />;
};
